export default {
  titles: {
    time: {
      count: {
        visit: 'Anzahl von HistoPad-Besichtigungen pro Tag',
        collected_treasure_count: 'Anzahl der gefundenen Schätze pro Tag',
        email: 'Anzahl der gesammelten E-Mail-Adressen pro Tag',
        comment: 'Anzahl der gesammelten Kommentare pro Tag',
        histomaton_file: 'Anzahl der aufgenommenen HistoSelfies pro Tag',
        affluence: 'Höchstes HistoPad-Besichtigungsaufkommen pro Tag',
        is_crash: 'Anzahl der HistoPad-Abstürze pro Tag',
        upload: 'Anzahl der hochgeladenen Protokolle pro Tag',
        uploaded_time: 'Anzahl der erstmalig hochgeladenen Protokolle pro Tag',
        uploaded_count: 'Anzahl der hochgeladenen Protokolle pro Tag',
        duplicate: 'Anzahl der doppelten Besichtigungen pro Tag',
        hotspot: 'Anzahl der angesehenen {0} pro Tag',
        cartel: 'Anzahl der angesehenen {0} pro Tag',
        immersive: 'Anzahl der angesehenen {0} pro Tag',
        augmentedvisit: 'Anzahl der angesehenen {0} pro Tag',
        interactiveobject: 'Anzahl der angesehenen {0} pro Tag',
        interactivebuilding: 'Anzahl der angesehenen {0} pro Tag',
        interactivecharacter: 'Anzahl der angesehenen {0} pro Tag',
        sequence: 'Anzahl der angesehenen {0} pro Tag',
        email_delivered: 'Anzahl der verschickten after-visit-emails  pro Tag',
        email_open: 'Anzahl der geöffneten after-visit-emails pro Tag',
        email_click: 'Anzahl der Klicks in den after-visit-emails pro Tag',
        email_delivered_session:
          'Number of HistoPad visits that received email after visit over time',
        email_open_session: 'Number of HistoPad visits that opened the email after visit over time',
        email_click_session: 'Number of HistoPad visits that clicked in mail after visit over time',
        survey_answer: 'Anzahl der begonnenen Umfragen pro Tag',
        inactivity_time: 'inaktive Zeit',
        area_visit: 'Anzahl der HistoPad-Besichtungen pro Tag im Raum',
        stuck_log: 'Anzahl von stecken Protokolle pro Tag',
      },
      average_count: {
        visit: 'Durchschnittliche Anzahl von HistoPad-Besuchen pro Tag',
        email: 'Durchschnittliche Anzahl der gesammelten E-Mail-Adressen pro Tag',
        comment: 'Durchschnittliche Anzahl der hinterlassenen Kommentare pro Tag',
        histomaton_file: 'Durchschnittliche Anzahl der aufgenommenen HistoSelfies pro Tag',
        affluence: 'Average number of attendances peaks per day',
        is_crash: 'Durchschnittliche Anzahl der Abstürze pro Tag',
        upload: 'Verlauf der durchschnittlichen Anzahl hochgeladener Logs pro Tag',
        uploaded_time: 'Durchschnittliche Anzahl erstmals hochgeladener Logs pro Tag',
        uploaded_count: 'History of the average of uploaded logs',
        duplicate: 'Durchschnittliche Anzahl hochgeladener Logs pro Tag',
        histopad_rating: 'Durchschnittliche Bewertung HistoPad pro Tag',
        visit_rating: 'Durchschnittliche Besuchsbewertung pro Tag',
        collected_treasure_count: 'Durchschnittliche Anzahl gefundener Schätze pro Tag',
        hotspot: 'Durchschnittliche Anzahl angesehener {0} pro Tag',
        cartel: 'Durchschnittliche Anzahl angesehener {0} pro Tag',
        immersive: 'Durchschnittliche Anzahl angesehener {0} pro Tag',
        augmentedvisit: 'Durchschnittliche Anzahl angesehener {0} pro Tag',
        interactiveobject: 'Durchschnittliche Anzahl angesehener {0} pro Tag',
        interactivebuilding: 'Durchschnittliche Anzahl angesehener {0} pro Tag',
        interactivecharacter: 'Durchschnittliche Anzahl angesehener {0} pro Tag',
        sequence: 'Durchschnittliche Anzahl angesehener {0} pro Tag',
        email_delivered: 'Durchschnittliche Anzahl gesendeter E-Mails pro Tag',
        email_open: 'Durchschnittliche Anzahl von after-visit-emails pro Tag',
        email_click: 'Durchschnittliche Anzahl von Klicks in after-visit-emails pro Tag',
        survey_answer: 'Durchschnittliche Anzahl von Klicks in after-visit-emails pro Tag',
        rotation: 'Durchschnittliche Anzahl HistoPad-Nutzung pro Tag',
        inactivity_time: 'inaktive Zeit',
        max_temperature: 'Maximum temperature average reached per day',
        min_temperature: 'Minimum temperature average reached per day',
        max_level: 'Maximum battery level average reached per day',
        min_level: 'Minimum battery level average reached per day',
        max_memory_level: 'Maximum memory level average reached per day',
        min_memory_level: 'Minimum memory level average reached per day',
        max_temperature_gradient: 'Average maximum slope of temperatures per day',
        min_level_gradient: 'Average maximum slope of battery level per day',
        max_memory_level_gradient: 'Average maximum slope of memory level per day',
      },
      average_time: {
        visit: 'Durchschnittsdauer der Besichtigung pro Tag',
        hotspot: 'Durchschnittliche Zeit verbracht in  {0} pro Tag',
        cartel: 'Durchschnittliche Zeit verbracht in  {0} pro Tag',
        immersive: 'Durchschnittliche Zeit verbracht in  {0} pro Tag',
        augmentedvisit: 'Durchschnittliche Zeit verbracht in  {0} pro Tag',
        interactiveobject: 'Durchschnittliche Zeit verbracht in  {0} pro Tag',
        interactivebuilding: 'Durchschnittliche Zeit verbracht in  {0} pro Tag',
        interactivecharacter: 'Durchschnittliche Zeit verbracht in  {0} pro Tag',
        sequence: 'Durchschnittliche Zeit verbracht in  {0} pro Tag',
        email_open: 'Durchschnittliche Zeit bevor die E-Mail geöffnet wird pro Tag',
        route_duration: 'History of average route duration',
        inactivity_time: 'History of average inactivity',
        area_visit: 'History of the average visit time in the area',
      },
      percentage: {
        email: 'Prozentsatz von Besuchern, die eine E-Mail-Adresse angeben pro Tag',
        comment: 'Prozentsatz der Besucher, die einen Kommentar abgeben, pro Tag',
        histomaton_file: 'Prozentsatz der Besucher, die ein HistoSelfie aufnehmen, pro Tag',
        is_crash: 'Prozentsatz der Abstürze pro Tag',
        histopad_rating: 'Prozentsatz der Besucher, die das HistoPad bewerten, pro Tag',
        visit_rating: 'Prozentsatz der Besucher, die das HistoPad bewerten, pro Tag',
        collected_treasure_count: 'Prozentsatz der Besuche mit gefundenem Schatz pro Tag',
        upload: 'History of the percentage of uploaded logs over unique visits',
        uploaded_count: 'Prozentsatz hochgeladener Logs pro Tag',
        duplicate: 'Prozentsatz doppelter Besuche pro Tag',
        email_delivered: 'Prozentsatz gesendeter after-visit-emails pro Tag',
        email_open: 'Prozentsatz geöffneter after-visit-emails pro Tag',
        email_click: 'Prozentsatz von Klicks in after-visit-emails pro Tag',
        email_delivered_session:
          'History of the percentage of visits that received email after visit',
        email_open_session: 'History of the percentage of visits that opened the email after visit',
        email_click_session:
          'History of the percentage of visits that clicked in the email after visit',
        survey_answer:
          'Prozentsatz der Besucher, die visit die Nach-Besichtigungs-R-Oute klicken, Verlauf',
        route_duration: 'Verlauf der Routendauer über die Besuchsdauer',
        inactivity_time: 'Vorgeschichte der Inaktivitätsrate',
        area_visit: 'Verlauf des Prozentsatzes der HistoPad-Besuche pro Tag in der Region',
      },
    },
    indicator: {
      count: {
        visit: 'Anzahl der HistoPad Besichtigungen',
        collected_treasure_count: 'Anzahl der gesammelten Schätze',
        email: 'Anzahl der gesammelten E-Mail-Adressen',
        comment: 'Anzahl der gesammelten Kommentare',
        histomaton_file: 'Anzahl der HistoSelfies',
        affluence: 'Anzahl der Besucherzahlen',
        is_crash: 'Anzahl der Abstürze',
        upload: 'Anzahl hochgeladener Logs',
        uploaded_time: 'Anzahl der erstmaligen hochgeladenen Protokolle',
        uploaded_count: 'Anzahl hochgeladener Logs',
        duplicate: 'Anzahl wiederholter Besuche',
        hotspot: 'Anzahl der gesehenen {0}',
        cartel: 'Anzahl der gesehenen {0}',
        immersive: 'Anzahl der gesehenen {0}',
        augmentedvisit: 'Anzahl der gesehenen {0}',
        interactiveobject: 'Anzahl der gesehenen {0}',
        interactivebuilding: 'Anzahl der gesehenen {0}',
        interactivecharacter: 'Anzahl der gesehenen {0}',
        sequence: 'Anzahl der gesehenen {0}',
        email_delivered: 'Anzahl der gesendeten after-visit-emails',
        email_open: 'Number of after visit email openings',
        email_click: 'Anzahl von Klicks in den after-visit-emails',
        email_delivered_session: 'Number of visits that received email after visit',
        email_open_session: 'Number of visits that opened the email after visit',
        email_click_session: 'Number of visits that clicked in the email after visit',
        survey_answer: 'Anzahl gestarteter Umfragen',
        area_visit: 'Anzahl von HistoPad-Besichtigungen im Raum',
        stuck_log: 'Anzahl von stecken Protokolle',
      },
      average_count: {
        visit: 'Durchschnittliche Anzahl von HistoPad-Besuchen',
        email: 'Durchschnittliche Anzahl gesammelter E-Mail-Adressen',
        comment: 'Durchschnittliche Anzahl gesammelter Kommentare',
        histomaton_file: 'Durchschnittliche Anzahl gesammelter HistoSelfies',
        affluence: 'Durchschnittliche Besucherzahl',
        is_crash: 'Durchschnittliche Abstürze',
        upload: 'Durchschnittlich hochgeladene Logs',
        uploaded_time: 'Durchschnittliche Anzahl erstmals hochgeladener Logs',
        uploaded_count: 'Durchschnittliche Anzahl hochgeladener Logs',
        duplicate: 'Durchschnittliche Anzahl doppelter Besuche',
        histopad_rating: 'Durchschnittliche HistoPad-Bewertung',
        visit_rating: 'Durchschnittliche Besichtigungsbewertung',
        collected_treasure_count: 'Durchschnittliche Anzahl gesammelter Schätze',
        hotspot: 'Durchschnittliche Anzahl gesehener {0} pro Besuch',
        cartel: 'Durchschnittliche Anzahl gesehener {0} pro Besuch',
        immersive: 'Durchschnittliche Anzahl gesehener {0} pro Besuch',
        augmentedvisit: 'Durchschnittliche Anzahl gesehener {0} pro Besuch',
        interactiveobject: 'Durchschnittliche Anzahl gesehener {0} pro Besuch',
        interactivebuilding: 'Durchschnittliche Anzahl gesehener {0} pro Besuch',
        interactivecharacter: 'Durchschnittliche Anzahl gesehener {0} pro Besuch',
        sequence: 'Durchschnittliche Anzahl gesehener {0} pro Besuch',
        email_delivered: 'Durchschnittliche Anzahl gesendeter after-visit-emails',
        email_open: 'Durchschnittliche Anzahl geöffneter after-visit-emails',
        email_click: 'Durchschnittliche Anzahl von Klicks in after-visit-emails',
        email_delivered_session: 'Average number of visits that received email after visit',
        email_open_session: 'Average number of visits that opened the email after visit',
        email_click_session: 'Average number of visits that clicked in the email after visit',
        survey_answer: 'Durchschnittliche Anzahl gestarteter Umfragen',
        area_visit: 'Durchschnittliche Anzahl von Besichtigungen in Räumen',
        max_temperature: 'Maximum temperature average reached',
        min_temperature: 'Minimum temperature average reached',
        max_level: 'Maximum battery level average reached',
        min_level: 'Minimum battery level average reached',
        max_memory_level: 'Maximum memory level average reached',
        min_memory_level: 'Minimum memory level average reached',
        max_temperature_gradient: 'Average maximum slope of temperatures',
        min_level_gradient: 'Average maximum slope of battery level',
        max_memory_level_gradient: 'Average maximum slope of memory level',
      },
      average_time: {
        visit: 'Durchschnittliche Besichtigungsdauer',
        hotspot: 'Durchschnittlich verbrachte Zeit in {0} pro Besichtigung',
        cartel: 'Durchschnittlich verbrachte Zeit in {0} pro Besichtigung',
        immersive: 'Durchschnittlich verbrachte Zeit in {0} pro Besichtigung',
        augmentedvisit: 'Durchschnittlich verbrachte Zeit in {0} pro Besichtigung',
        interactiveobject: 'Durchschnittlich verbrachte Zeit in {0} pro Besichtigung',
        interactivebuilding: 'Durchschnittlich verbrachte Zeit in {0} pro Besichtigung',
        interactivecharacter: 'Durchschnittlich verbrachte Zeit in {0} pro Besichtigung',
        sequence: 'Durchschnittlich verbrachte Zeit in {0} pro Besichtigung',
        email_open: 'Durchschnittliche Zeit vor Öffnung der E-Mail',
        route_duration: 'Durchschnittliche Routendauer',
        inactivity_time: 'Durchschnittliche Inaktivitätsdauer',
        area_visit: 'Durchschnittliche Aufenthaltsdauer im Raum',
      },
      percentage: {
        email: 'Prozentsatz der Besucher, die ihre E-Mail-Adresse hinterlassen haben',
        comment: 'Prozentsatz der Besucher, die einen Kommentar abgefasst haben',
        histomaton_file: 'Prozentsatz der Besucher, die ein HistoSelfie aufgenommen habe',
        is_crash: 'Prozentsatz der Abstürze',
        histopad_rating: 'Prozentsatz der Besucher, die das HistoPad bewertet haben',
        visit_rating: 'Prozentsatz der Besucher, die die Besichtigung bewertet haben pro Tag',
        collected_treasure_count: 'Prozentsatz von Besichtigungen mit Schatzfunden pro Tag',
        upload: 'Prozentsatz hochgeladener Logs über hochgeladene Einzelbesuche',
        uploaded_count: 'Prozentsatz hochgeladener Logs',
        duplicate: 'Prozentsatz wiederholter Besichtigungen',
        email_delivered: 'Prozentsatz gesendeter after-visit-emails',
        email_open: 'Prozentsatz geöffneter after-visit-emails',
        email_click: 'Prozentsatz von Klicks in after-visit-emails',
        email_delivered_session: 'Percentage of visits that received email after visit',
        email_open_session: 'Percentage of visits that opened the email after visit',
        email_click_session: 'Percentage of visits that clicked in the email after visit',
        survey_answer: 'Prozentsatz gestarteter Umfragen',
        route_duration: 'Routendauer im Verhältnis zur Besichtigungsdauer',
        inactivity_time: 'Inaktivitätsrate',
        area_visit: 'Prozentsatz von HistoPad-Besichtigungen im Raum',
      },
    },
    distribution: {
      visit: 'Verteilung der Besichtigungen',
      email: 'Verteilung der Besichtigungen mit E-Mail',
      comment: 'Verteilung der Besichtigungen mit Kommentar',
      histomaton_file: 'Verteilung der Besichtigungen mit HistoSelfies',
      is_crash: 'Verteilung Abstürze',
      upload: 'Verteilung hochgeladener Logs',
      uploaded_time: 'Verteilung hochgeladene Besichtigungen',
      uploaded_count: 'Verteilung hochgeladener Logs',
      duplicate: 'Verteilung wiederholte Besichtigungen',
      email_delivered: 'Verteilung der gesendeten after-visit-emails',
      email_open: 'Verteilung der geöffneten after-visit-emails',
      email_click: 'Verteilung der Klicks in after-visit-emails',
      email_delivered_session: 'Distribution of visits that received email after visit',
      email_open_session: 'Distribution of visits that opened the email after visit',
      email_click_session: 'Distribution of visits that clicked in the email after visit',
      collected_treasure_count: 'Verteilung der gefundenen Schätze',
      survey_answer: 'Verteilung der gestarteten Umfragen',
      stuck_log: 'Verteilung der stecken Protokolle',
    },
    day: {
      count: {
        visit: 'History of HistoPad visits during a day',
        email: 'History of email addresses collected during a day',
        comment: 'History of comments left during a day',
        histomaton_file: 'History of HistoSelfie during a day',
        affluence: 'History of affluences peaks during a day',
        is_crash: 'Verlauf Abstürze am Tag',
        uploaded_time: 'Verlauf hochgeladener Logs am Tag',
        upload: 'Hochgeladene Logs am Tag',
      },
    },
    rotation: {
      count: {
        visit: 'Anzahl der Nutzung pro Tablet',
        email: 'Anzahl der Nutzung mit hinterlassener E-Mail pro Tablet',
        comment: 'Anzahl der Nutzung mit hinterlassenen Kommentaren pro Tablet',
        histomaton_file: 'Anzahl der Nutzung mit HistoSelfie pro Tablet',
        is_crash: 'Anzahl der Nutzung mit Abstürzen pro Tablet',
      },
    },
    matrix: {
      count: {
        affluence: 'Heatmap der Besucherzahlen über die Zeit',
      },
    },
  },
}
